'use strict';
var base = require('./base');
var processInclude = require('base/util');
processInclude(require('./informationsProduct'));



/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}


function SizeSelected() {
    if (!window.customer.isB2B) {
        var quantitySelector = $('.b2b-customer.b2c-customer .quantity-select');
        if ($(".size-field.selected").length > 0) {
            $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        } else {
            $('.add-to-cart .label-select-size').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-add-to-cart').removeClass('d-block').addClass('d-none');
            $('.label-select-size').parents('.add-to-cart').removeClass('btn-primary').addClass('btn-blue disabled-btn');
        }

        if ($(".size-field.selectable").length == 0) {
            $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary disabled-btn');
        }

        if ($('.add-to-cart').parents('.attributes').find('.variation-container').hasClass('no-size')) {
            $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }

        if ($('.size-field').length > 0) { 
            if ($('.size-field.selected').length === 0) {
                quantitySelector.prop('disabled', true).addClass('btn-qt-disabled');
                $('.quantity-btn').addClass('btn-qt-disabled');
            } else {
                quantitySelector.prop('disabled', false).removeClass('btn-qt-disabled');
                $('.quantity-btn').removeClass('btn-qt-disabled');
            }
        }
        
    } else {
        var quantitySelector = $('.b2b-customer:not(.b2c-customer) .quantity-select');
        if ($(".js-b2b-quantity-select:not(.disabled-select)").length > 0 && $('.js-b2b-quantity-select').val() == "0") {
            $('.add-to-cart .label-select-size').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-add-to-cart').removeClass('d-block').addClass('d-none');
            $('.label-select-size').parents('.add-to-cart').removeClass('btn-primary').addClass('btn-blue disabled-btn');
        } else {
            $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }
        $('.js-b2b-quantity-select:not(.disabled-select)').on('change', function () {
            var selectedValue = $(this).val();
        
            if (selectedValue !== "0") { 
                $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            } else {
                $(this).closest('.add-to-cart').find('.label-select-size').removeClass('d-none').addClass('d-block');
                $(this).closest('.add-to-cart').find('.label-add-to-cart').removeClass('d-block').addClass('d-none');
                $(this).closest('.add-to-cart').removeClass('btn-primary').addClass('btn-blue disabled-btn');
            }
        
            var allZero = $('.js-b2b-quantity-select:not(.disabled-select)').toArray().every(function (select) {
                return $(select).val() === "0";
            });
        
            if (allZero) {
                $('.add-to-cart .label-select-size').removeClass('d-none').addClass('d-block');
                $('.add-to-cart .label-add-to-cart').removeClass('d-block').addClass('d-none');
                $('.label-select-size').parents('.add-to-cart').removeClass('btn-primary').addClass('btn-blue disabled-btn');
            }
        });    

        $('.js-b2b-quantity-select:not(.disabled-select)').each(function () {
            if ($(this).val() !== "0") {
                $('.add-to-cart .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            }
        });
    }
}
SizeSelected();

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                if (!window.customer.isB2B || !response.attribute) {
                    response.container.data('pid', response.data.product.id);
                    response.container.find('.product-id').text(response.data.product.id);
                } else {
                    var quantityInputID = "quantities_" + response.attribute.id + '_' + response.attribute.value;
                    $('input#' + quantityInputID).val(response.data.product.id);
                    var _availableTxt = $('.js-availability-message-container-' + response.attribute.id + '-' + response.attribute.value).attr('data-text-available');
                    var _unavailableTxt = $('.js-availability-message-container-' + response.attribute.id + '-' + response.attribute.value).attr('data-text-unavailable');
                    var $txtContainer = $('.js-availability-message-' + response.attribute.id + '-' + response.attribute.value) ;
                    var $quantitySelect = $('#select_quantity_'  + response.attribute.id + '_' +  response.attribute.value);
                    if (response.data.product.available === true && response.data.product.readyToOrder) {
                        $txtContainer.empty().text(_availableTxt);
                        $quantitySelect.data('available', true);
                    } else {
                        $txtContainer.empty().text(_unavailableTxt);
                        $quantitySelect.data('available', false);
                    }
                }
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            SizeSelected();
        });
        $(document).on("click",".size-field", function(event) {
            var $productContainer = $(this).closest('.product-detail');
            var errorMessage = $productContainer.find('.size-error-message');
            $(this).parents('.sizes-container-block').find('.select-size').val($(this).data("attr-value")).trigger('change');
            $(".size-field").removeClass("selected");
            $(this).addClass("selected");
            $('.quantity-select').removeClass('btn-qt-disabled');
            $('.quantity-btn').removeClass('btn-qt-disabled');
            $('.quantity-select').removeAttr('disabled');
            errorMessage.css('display', 'none');
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {

            if (!window.customer.isB2B) {
                // update local add to cart (for sets)
                $('button.add-to-cart', response.$productContainer)
                    .toggleClass('disabled-btn', (!response.product.readyToOrder || !response.product.available));
                var enable = $('.product-availability').toArray().every(function (item) {
                    return $(item).data('available') && $(item).data('ready-to-order');
                });
            } else {
                // update local add to cart (for sets)
                $('button.add-to-cart', response.$productContainer)
                    .toggleClass('disabled-btn', (!response.product.readyToOrder || !response.product.available));
                var enable = $('.js-b2b-quantity-select').toArray().every(function (item) {
                    return $(item).data('available');

                });
            }
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    DOMContentLoaded: function() {
        var sizeSelector = $('.custom-select.select-TEC_size');
        var quantitySelector = $('.quantity-select');
        var addToCartButton = $('.add-to-cart');
        var errorMessage = $('.size-error-message');
        if (!window.customer.isB2B) {
            if (errorMessage.length && sizeSelector.length) {
                function checkSizeSelection(event) {
                    if ($('.size-field.selected').length === 0) {
                        event.preventDefault();
                        errorMessage.css('display', 'block');
                        quantitySelector.prop('disabled', true).addClass('btn-qt-disabled');
                        $('.quantity-btn').addClass('btn-qt-disabled');
                    } else {
                        errorMessage.css('display', 'none');
                        quantitySelector.prop('disabled', false).removeClass('btn-qt-disabled');
                        $('.quantity-btn').removeClass('btn-qt-disabled');
                    }
                }
            
                sizeSelector.on('change', function () {
                    if ($('.size-field.selected').length === 0) {
                        errorMessage.css('display', 'none');
                        quantitySelector.prop('disabled', false).removeClass('btn-qt-disabled');
                        $('.quantity-btn').removeClass('btn-qt-disabled');
                    }
                });
            
                quantitySelector.on('click', checkSizeSelection);
                addToCartButton.on('click', checkSizeSelection);
            }        
        } else {
            function checkSizeSelectionb2b(event) {
                var allZero = true;
                event.preventDefault();
                if ($('.js-b2b-quantity-select:not(:disabled)').length > 0) {
                    $('.js-b2b-quantity-select:not(:disabled)').each(function () {
                        if ($(this).val() !== '0') {
                            allZero = false;
                            return false;
                        }
                    });
    
                    var errorMessage = $('.size-error-message');
                    if (allZero) {
                        errorMessage.css('display', 'block');
                    } else {
                        errorMessage.css('display', 'none');
                    }
                }
            }
            addToCartButton.on('click', checkSizeSelectionb2b);
        } 

        $('.quantity-btn').on('click', function (event) {
            var quantitySelector = $('.quantity-select');
            var errorMessage = $('.size-error-message');
            if ($('.size-field').length > 0) { 
                if ($('.size-field.selected').length === 0) {
                    event.preventDefault();
                    errorMessage.css('display', 'block');
                    quantitySelector.addClass('btn-qt-disabled');
                    $('.quantity-btn').addClass('btn-qt-disabled');
                } else {
                    errorMessage.css('display', 'none');
                    quantitySelector.removeClass('btn-qt-disabled');
                    $('.quantity-btn').removeClass('btn-qt-disabled');
                }
            }
        });
        

        $('.size-selector-container').each(function () {
            const $select = $(this).find('select');
            $select.on('focusin', function(e) {
                e.preventDefault();
                    $(this).addClass('focused');
                })
                .on('focusout', function(e) {
                    e.preventDefault();
                        $(this).removeClass('focused');
                    });

            $(this).find('.plus-btn').on('click', function () {
                if ($select.prop('selectedIndex') < $select.find('option').length - 1) {
                    $select.prop('selectedIndex', $select.prop('selectedIndex') + 1).trigger('change');
                }
            });

            $(this).find('.minus-btn').on('click', function () {
                if ($select.prop('selectedIndex') > 0) {
                    $select.prop('selectedIndex', $select.prop('selectedIndex') - 1).trigger('change');
                }
            });
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};

$('.lien-complet').on('click', function(e) {
    e.preventDefault();

    var $header = $('header');
    var $target = $('.informations-Product');

    if ($target.length) {

        var headerHeight = $header.outerHeight() || 0;

        if ($(window).width() > 992) {
            $('html, body').animate({
                scrollTop: $target.offset().top - headerHeight
            }, 800);
        } else {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 800);
        }
    }
});

var $ctaButton = $('.add-to-cart-scroll');
var $stickyBar = $('.sticky-bar-product');
var $header = $('header');

function isPartiallyVisible($el) {
    var winTop = $(window).scrollTop();
    var elTop = $el.offset().top;
    var headerHeight = $header.outerHeight();
    return !(elTop >= winTop + headerHeight);
}

function toggleStickyBar() {
    if ($(window).width() > 1024) {
        if (isPartiallyVisible($ctaButton)) {
            $stickyBar.fadeIn();
        } else {
            $stickyBar.fadeOut();
        }
    } else {
        $stickyBar.hide();
    }
}

$(window).on('scroll', toggleStickyBar);
$(window).on('resize', toggleStickyBar);

$(document).on('click', '.sticky-bar-product .add-to-cart', function (event) {
    var $productContainer = $(this).closest('.product-detail');
    var $errorMessage = $productContainer.find('.size-error-message');
    var $variationContainer = $('.info-product');

    if ($('.size-field.selected').length === 0) {
        if (window.innerWidth > 544) {
            $('html, body').animate({
                scrollTop: $variationContainer.offset().top
            }, 500);
        }
        $errorMessage.css('display', 'block');
        event.preventDefault();
        return;
    } else {
        $errorMessage.css('display', 'none');
    }
});

$(document).on('click', '.zoom-icon-js', function (event) {
    event.preventDefault();
    let currentIndexPosition = parseInt($('.carousel-indicators li.active').attr('data-slide-to')) || 0;
    openModal(currentIndexPosition);
})

function openModal(currentIndex) {
    const $imagesPrimary = $('#imageGalleryModal .carousel-item');
    const $imagesModal = $('#imageGalleryModal .js-carousel-item');
    const $currentImageElement = $('#currentImage');
    const $totalImagesElement = $('#totalImages');
    const $prevButton = $('#prevImage');
    const $nextButton = $('#nextImage');
    const totalImages = $imagesModal.length;

    $totalImagesElement.text(totalImages);

    const updateGallery = () => {
        $imagesPrimary.removeClass('active').eq(currentIndex).addClass('active');
        $('.carousel-indicators li').removeClass('active').eq(currentIndex).addClass('active');
        $('.pdpCarousel .carousel-inner').removeClass('active').eq(currentIndex).addClass('active');
        $('.js-pdp-carousel').find('.carousel-item').removeClass('active').eq(currentIndex).addClass('active');
        $imagesModal.removeClass('active').eq(currentIndex).addClass('active');
        $currentImageElement.text(currentIndex + 1);
        $prevButton.toggleClass('d-none', currentIndex === 0);
        $nextButton.toggleClass('d-none', currentIndex === totalImages - 1);
    };

    $prevButton.on('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            updateGallery();
        }
    });

    $nextButton.on('click', () => {
        if (currentIndex < totalImages - 1) {
            currentIndex++;
            updateGallery();
        }
    });

    $imagesPrimary.on('click', function () {
        currentIndex = $imagesPrimary.index(this);
        updateGallery();
    });
    
    updateGallery();
    $('#imageGalleryModal').modal('show');
}

function resetForm() {
    $('.tec-backinstock-size input[name="variantIds"]').prop('checked', false);
    $('.error-email-message').addClass('d-none');
    $('.alert-send-email-bis').addClass("d-none");
    $('#email').val('');
}

$('.add-to-back-in-stock').on('click', function (e) {
    e.preventDefault();

    $('.error-email-message').addClass('d-none');
    $('.control-form-email').removeClass('error');
    $('.alert-send-email-bis').addClass("d-none");

    let isValid = true;

    const sizeSelected = $('.tec-backinstock-size input[name="variantIds"]:checked').length > 0;
    if (!sizeSelected) {
        $('.tec-backinstock-container .error-email-message').removeClass('d-none');
        isValid = false;

        if ($('.tec-backinstock-size input[name="variantIds"]').length === 0) {
            isValid = true;
        }
    }

    const emailInput = $('#email').val().trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailInput || !emailRegex.test(emailInput)) {
        $('.tec-mail-alerte + .error-email-message').removeClass('d-none');
        $('.control-form-email').addClass('error');
        isValid = false;
    }

    if (isValid) {
        const formData = $('.back-in-stock-form').serialize();
        const actionUrl = $('.back-in-stock-form').attr('action');

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data: formData,
            success: function (response) {
                if(response.success) {
                    $('.alert-send-email-bis').alert();
                    $('.alert-send-email-bis').removeClass("d-none");
                }
            },
            error: function () {
                alert('Une erreur s\'est produite. Veuillez réessayer.');
            }
        });
    }
});


$(document).on('click', '.subscribe-back-in-stock', function (event) {
    if (!window.customer.isB2B) {
        $('.tec-backinstock-size').empty();

        $('.select-all-size .size-unselectable').each(function() {
            var dataValue = $(this).data('product-id');
            var sizeText = $(this).text().trim();
            var newLabel = `
                <label class="size-option">
                    <input type="checkbox" name="variantIds" value="${dataValue}">
                    <span>${sizeText}</span>
                </label>
            `;
            $('.tec-backinstock-size').append(newLabel);
        });
    } else {
        $('.tec-backinstock-size').empty();

        $('.b2b-customer .b2b-size-unselectable').each(function() {
            var dataValue = $(this).data('product-id');
            var sizeText = $(this).find('.b2b-label-size').text().trim();
            var newLabel = `
                <label class="size-option">
                    <input type="checkbox" name="variantIds" value="${dataValue}">
                    <span>${sizeText}</span>
                </label>
            `;
            $('.tec-backinstock-size').append(newLabel);
        });
    }
});

function toggleSubscribeBackInStockB2b() {
    if ($('.b2b-size-unselectable').length > 0 ) {
        $('.show-back-in-stock-b2b').addClass('d-lg-block').removeClass('d-none');
    } else {
        $('.show-back-in-stock-b2b').addClass('d-none').removeClass('d-lg-block');
    }
}

toggleSubscribeBackInStockB2b();

$('.size-field').on('click', function() {
    toggleSubscribeBackInStockB2b();
});

function toggleSubscribeBackInStock() {
    if ($('.size-unselectable.size-field').length > 0 ) {
        $('.show-back-in-stock').addClass('d-lg-block').removeClass('d-none');
    } else {
        $('.show-back-in-stock').addClass('d-none').removeClass('d-lg-block');
    }
}

toggleSubscribeBackInStock();

$('.size-field').on('click', function() {
    toggleSubscribeBackInStock();
});

$(document).on('click', '#cartIconBtn', function (event) {
    $('#backInStockAlert').modal('hide');
    resetForm();
});


$('.js-close-success-message').on('click', function () {
    $('#backinstock-success-message').modal('hide');
});

$('.tec-badge span').each(function() {
    if ($(this).text().trim() !== '') {
        $(this).closest('.tec-badge').addClass('badge-exist');
    }
});

if ($('.size-field.selected').length === 0 && $('.size-field').length > 0) {
    $("select.quantity-select").html('<option value="0">0</option>');
}